/**
 * Filter a list by a search query, matching against the given keys (string values).
 */
export function filterListByQuery<T>(
  list: T[],
  query: string,
  keys: (keyof T)[]
): T[] {
  const q = query.trim().toLowerCase();
  if (!q) return list;
  return list.filter((item) =>
    keys.some((k) => String(item[k] ?? '').toLowerCase().includes(q))
  );
}
